import moment from 'moment';

export const DATE_FORMAT_STRING = 'YYYY-MM-DD HH:mm:ss';
export const columns = [
  {
    key: "start_time",
    header: "start_time",
    width: 168,
    render: cvm => {
      return cvm.start_time ? moment(cvm.start_time).format(DATE_FORMAT_STRING) : '';
    },
  },
  {
    key: "end_time",
    header: "end_time",
    width: 168,
    render: cvm => {
      return cvm.end_time ? moment(cvm.end_time).format(DATE_FORMAT_STRING) : '';
    },
  },
  // {
  //   key: "openid",
  //   header: "openid",
  // },
  {
    key: "pvpid",
    header: "pvpid",
    width: 246,
  },
  {
    key: "game_ip",
    header: "game_ip",
    width: 160,
  },
  {
    key: "vpn_ip",
    header: "vpn_ip",
    width: 160,
  },
  {
    key: "country",
    header: "country",
    width: 150,
  },
  {
    key: "province",
    header: "province",
    width: 160,
  },
  {
    key: "operator",
    header: "operator",
    width: 160,
  },
  {
    key: "gameextra",
    header: "gameextra",
    width: 200,
  },
  {
    key: "lag",
    header: "lag",
    width: 160,
  },
  {
    key: "origtime",
    header: "origtime",
    width: 160,
  }
];

export const testData = () => {
  return {
    openid: 'xxxxxx',
    pvpid: Math.floor(Math.random() * 100000000000).toString(),
    start_time: '2021-06-21 12:01:22',
    end_time: '2021-06-21 12:27:31',
    game_ip: 'ddd',
    vpn_ip: 'fffff',
    country: '中国',
    province: '广东',
    operator: '',
    gameextra: 'sdfasdfsdf',
    network: 'ffff',
    lag: '',
    origtime: '',
    normalvalue: '255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100,255,100,0,280,700,360,45,,,,16,24,5,100'
  }
}
